import {callAPI} from '@/store/utils'; // eslint-disable-line
import {getDemoCounterparties} from '@/data/demoData';

export default {
  namespaced: true,
  state: {
    counterpartiesList: [],
    counterpartiesDDList: [],
  },
  mutations: {
    setCounterPartiesList(state, res) {
      state.counterpartiesList = res?.result?.data || [];
    },
    setCounterPartiesDDList(state, res) {
      state.counterpartiesDDList = res?.result || [];
    },
  },
  actions: {
    async actionCreateCounterParty({rootState}, params) {
      return await callAPI(
        'POST',
        `company/${rootState.companyId}/counterparty-and-accountCounterparty`,
        params,
      );
    },
    async actionGetCounterPartiesList({rootState, rootGetters, commit}, params) {
      // Demo companies: prepend hardcoded beneficiaries so the sales demo shows a
      // full list. We still merge in any real backend rows (a demo company is a
      // real backend company) and fall back to fixtures only if the call fails.
      if (rootGetters['user/isDemoAccount']) {
        const demoItems = getDemoCounterparties(params?.kind, params?.search);
        let backendData = [];
        try {
          const backend = await callAPI(
            'POST',
            `company/${rootState.companyId}/counterparties`,
            params,
          );
          backendData = backend?.result?.data || [];
        } catch {
          // demo: ignore backend errors, show fixtures only
        }
        const data = [...demoItems, ...backendData];
        const res = {
          error: false,
          result: {
            data,
            recordsFiltered: data.length,
            recordsTotal: data.length,
          },
        };
        commit('setCounterPartiesList', res);
        return res;
      }
      const res = await callAPI(
        'POST',
        `company/${rootState.companyId}/counterparties`,
        params,
      );
      commit('setCounterPartiesList', res);
      return res;
    },
    async actionGetCounterPartiesDDList({commit, rootState}) {
      const res = await callAPI(
        'GET',
        `company/${rootState.companyId}/counterpartiesDD`,
      );
      commit('setCounterPartiesDDList', res);
      return res;
    },
    async actionUpdateCounterParty({rootState}, params) {
      const res = await callAPI(
        'PUT',
        `company/${rootState.companyId}/counterparty/${params.cpId}`,
        params.counterparty,
      );
      return res;
    },
    async actionDeleteCounterParty({rootState}, cpId) {
      const res = await callAPI(
        'DELETE',
        `company/${rootState.companyId}/counterparty/${cpId}`,
      );
      return res;
    },
    async actionProcessUploadedFile({rootState}, params) {
      const res = await callAPI('POST', 'processCounterPartyUploadedFile', {
        params,
        id: rootState.companyId,
      });
      return res;
    },
    async actionCreateCounterPartyIban({rootState}, params) {
      const res = await callAPI(
        'POST',
        `company/${rootState.companyId}/counterparty/${params.cpId}/accountCounterparty`,
        params,
      );
      return res;
    },
    async actionGetCounterPartyIbans({rootState}, params) {
      const res = await callAPI(
        'GET',
        `company/${rootState.companyId}/counterparty/${params.cpId}/accountCounterparties`,
      );
      return res;
    },
    async actionGetPaymentPurposeCodes({rootState}, params) {
      const query = new URLSearchParams({
        country: params.country,
        currency: params.currency,
        kind: params.kind,
      }).toString();
      return await callAPI(
        'GET',
        `company/${rootState.companyId}/equals/paymentPurposeCodes?${query}`,
      );
    },
    async actionGetCounterParty({rootState}, params) {
      const res = await callAPI(
        'GET',
        `company/${rootState.companyId}/counterparty/${params.cpId}`,
      );
      return res;
    },
    async actionValidateIban(_, params) {
      return await callAPI('POST', 'validateIban', {iban: params.iban});
    },
    async actionEditCounterPartyIban({rootState}, params) {
      const res = await callAPI(
        'PUT',
        `company/${rootState.companyId}/counterparty/${params.cpId}/accountCounterparty/${params?.iban?.id}`,
        params.iban,
      );
      return res;
    },
    async actionSetDefaultCounterPartyIban({rootState}, params) {
      const res = await callAPI(
        'PUT',
        `company/${rootState.companyId}/counterparty/${params.cpId}/accountCounterparty/${params.id}/setDefault`,
      );
      return res;
    },
    async actionDeleteCounterPartyIban({rootState}, params) {
      const res = await callAPI(
        'DELETE',
        `company/${rootState.companyId}/counterparty/${params.cpId}/accountCounterparty/${params.id}`,
      );
      return res;
    },
  },
};
